<div class="col-lg-12">
  <div class="mb-3 d-flex gap-3 align-items-center panel-tags">
    <!-- <div class="col-lg d-flex gap-3 green-tag p-radius justify-content-between">
      <p-tag value="YTD GP $26,485,021.04" class="green-tag" />
      <p-tag value=" GP% 35.89" class="green-tag" />
    </div>
    <div class="col-lg p-radius">
      <p-tag value="CDI’s 154" class="sky-tag" />
    </div>
    <div class="col-lg p-radius">
      <p-tag value="invoice Preview 234" class="gray-tag" />
    </div>
    <div class="col-lg p-radius">
      <p-tag value="Pending Chargebacks 2874" class="fer-tag" />
    </div>
    <div class="col-lg p-radius">
      <p-tag value="Disputed Invoices 4" class="sky2-tag" />
    </div>
    <div class="col-lg p-radius">
      <p-tag value="Expiring Protection 0" class="darkgray-tag" />
    </div> -->

    <div
      class="col-lg p-radius cursor-pointer"
      (click)="redirectToSummaryPage(item.cardTitle)"
      *ngFor="let item of cardList"
      [ngClass]="
        item.cardTitle.includes('YTD GP')
          ? 'd-flex gap-3 justify-content-between col-auto'
          : ''
      ">
      <p-tag
        *ngIf="item.cardTitle.includes('YTD GP')"
        [innerHtml]="item.cardTitle"
        [ngClass]="item.colorCode" />
      <p-tag
        *ngIf="!item.cardTitle.includes('YTD GP')"
        value="{{ item.cardTitle }} {{ item.cardValue }}"
        [ngClass]="item.colorCode" />
    </div>
  </div>
</div>
